import { render, staticRenderFns } from "./OrderInvoiceData.vue?vue&type=template&id=bab033c0&"
import script from "./OrderInvoiceData.vue?vue&type=script&lang=js&"
export * from "./OrderInvoiceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports